var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLNonEmptyString, GraphQLURL } from "graphql-scalars";
import { ArgsType, Field, InputType, Int, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { NotificationDeliveryNode, NotificationNode, } from "../resources/Notification.js";
import { TeamType } from "../resources/Team.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListNotificationsResponse = class ListNotificationsResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [NotificationNode], { nullable: false }),
    __metadata("design:type", Array)
], ListNotificationsResponse.prototype, "data", void 0);
ListNotificationsResponse = __decorate([
    ObjectType("ListNotificationsResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListNotificationsResponse);
export { ListNotificationsResponse };
let NotificationAudienceInput = class NotificationAudienceInput {
    all;
    memberOfTeamType;
    memberOfTeams;
    users;
};
__decorate([
    Field(() => Boolean, { nullable: true }),
    __metadata("design:type", Boolean)
], NotificationAudienceInput.prototype, "all", void 0);
__decorate([
    Field(() => TeamType, { nullable: true }),
    __metadata("design:type", Object)
], NotificationAudienceInput.prototype, "memberOfTeamType", void 0);
__decorate([
    Field(() => [GlobalIdScalar], { nullable: true }),
    __metadata("design:type", Object)
], NotificationAudienceInput.prototype, "memberOfTeams", void 0);
__decorate([
    Field(() => [GlobalIdScalar], { nullable: true }),
    __metadata("design:type", Object)
], NotificationAudienceInput.prototype, "users", void 0);
NotificationAudienceInput = __decorate([
    InputType()
], NotificationAudienceInput);
let StageNotificationArgs = class StageNotificationArgs {
    title;
    body;
    url;
    audience;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], StageNotificationArgs.prototype, "title", void 0);
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], StageNotificationArgs.prototype, "body", void 0);
__decorate([
    Field(() => GraphQLURL, { nullable: true }),
    __metadata("design:type", Object)
], StageNotificationArgs.prototype, "url", void 0);
__decorate([
    Field(() => NotificationAudienceInput, { nullable: false }),
    __metadata("design:type", NotificationAudienceInput)
], StageNotificationArgs.prototype, "audience", void 0);
StageNotificationArgs = __decorate([
    ArgsType()
], StageNotificationArgs);
export { StageNotificationArgs };
let ListNotificationsArgs = class ListNotificationsArgs extends FilteredListQueryArgs("NotificationResolver", [
    "createdAt",
    "updatedAt",
    "title",
    "body",
    "deliveryIssue",
    "sendAt",
    "startedSendingAt",
    "deliveryIssueAcknowledgedAt",
]) {
};
ListNotificationsArgs = __decorate([
    ArgsType()
], ListNotificationsArgs);
export { ListNotificationsArgs };
let ListNotificationDeliveriesArgs = class ListNotificationDeliveriesArgs extends FilteredListQueryArgs("NotificationDeliveryResolver", ["createdAt", "updatedAt", "sentAt", "receiptCheckedAt", "deliveryError"]) {
    notificationUuid;
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], ListNotificationDeliveriesArgs.prototype, "notificationUuid", void 0);
ListNotificationDeliveriesArgs = __decorate([
    ArgsType()
], ListNotificationDeliveriesArgs);
export { ListNotificationDeliveriesArgs };
let ListNotificationDeliveriesResponse = class ListNotificationDeliveriesResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [NotificationDeliveryNode], { nullable: false }),
    __metadata("design:type", Array)
], ListNotificationDeliveriesResponse.prototype, "data", void 0);
ListNotificationDeliveriesResponse = __decorate([
    ObjectType("ListNotificationDeliveriesResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListNotificationDeliveriesResponse);
export { ListNotificationDeliveriesResponse };
let NotificationDeliveryIssueCount = class NotificationDeliveryIssueCount {
    DeviceNotRegistered;
    InvalidCredentials;
    MessageTooBig;
    MessageRateExceeded;
    MismatchSenderId;
    Unknown;
};
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], NotificationDeliveryIssueCount.prototype, "DeviceNotRegistered", void 0);
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], NotificationDeliveryIssueCount.prototype, "InvalidCredentials", void 0);
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], NotificationDeliveryIssueCount.prototype, "MessageTooBig", void 0);
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], NotificationDeliveryIssueCount.prototype, "MessageRateExceeded", void 0);
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], NotificationDeliveryIssueCount.prototype, "MismatchSenderId", void 0);
__decorate([
    Field(() => Int, { nullable: false }),
    __metadata("design:type", Number)
], NotificationDeliveryIssueCount.prototype, "Unknown", void 0);
NotificationDeliveryIssueCount = __decorate([
    ObjectType("NotificationDeliveryIssueCount", {
        description: "The number of delivery issues for a notification, broken down by type.",
    })
    //implements Record<NotificationError, number>
], NotificationDeliveryIssueCount);
export { NotificationDeliveryIssueCount };
//# sourceMappingURL=GetNotificationByUuidResponse.js.map